var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, type, required, Schema, defaultValue } from "./decorators/type.js";
import { registerSchema } from "./components/ComponentRegistry.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class GraphicCircleSchema extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "radius");
  }
}
__decorateClass([
  type("number"),
  required()
], GraphicCircleSchema.prototype, "x", 2);
__decorateClass([
  type("number"),
  required()
], GraphicCircleSchema.prototype, "y", 2);
__decorateClass([
  type("number"),
  required()
], GraphicCircleSchema.prototype, "radius", 2);
class GraphicEllipseSchema extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "width");
    __publicField(this, "height");
  }
}
__decorateClass([
  type("number"),
  required()
], GraphicEllipseSchema.prototype, "x", 2);
__decorateClass([
  type("number"),
  required()
], GraphicEllipseSchema.prototype, "y", 2);
__decorateClass([
  type("number"),
  required()
], GraphicEllipseSchema.prototype, "width", 2);
__decorateClass([
  type("number"),
  required()
], GraphicEllipseSchema.prototype, "height", 2);
class GraphicRectangleSchema extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "width");
    __publicField(this, "height");
  }
}
__decorateClass([
  type("number"),
  required()
], GraphicRectangleSchema.prototype, "x", 2);
__decorateClass([
  type("number"),
  required()
], GraphicRectangleSchema.prototype, "y", 2);
__decorateClass([
  type("number"),
  required()
], GraphicRectangleSchema.prototype, "width", 2);
__decorateClass([
  type("number"),
  required()
], GraphicRectangleSchema.prototype, "height", 2);
let GraphicSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "scale");
    __publicField(this, "initialScale");
    __publicField(this, "rotation");
    __publicField(this, "xoffset");
    __publicField(this, "yoffset");
    __publicField(this, "zIndex");
    __publicField(this, "inheritParentZIndex");
    __publicField(this, "relativeZIndex");
    __publicField(this, "opacity");
    __publicField(this, "anchorX");
    __publicField(this, "anchorY");
    __publicField(this, "fillColor");
    __publicField(this, "strokeColor");
    __publicField(this, "lineWidth");
    __publicField(this, "circle");
    __publicField(this, "ellipse");
    __publicField(this, "rectangle");
    __publicField(this, "polygon");
  }
};
__decorateClass([
  type("number"),
  defaultValue(1)
], GraphicSchema.prototype, "scale", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], GraphicSchema.prototype, "initialScale", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], GraphicSchema.prototype, "rotation", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], GraphicSchema.prototype, "xoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], GraphicSchema.prototype, "yoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], GraphicSchema.prototype, "zIndex", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], GraphicSchema.prototype, "inheritParentZIndex", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], GraphicSchema.prototype, "relativeZIndex", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], GraphicSchema.prototype, "opacity", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], GraphicSchema.prototype, "anchorX", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], GraphicSchema.prototype, "anchorY", 2);
__decorateClass([
  type("string")
], GraphicSchema.prototype, "fillColor", 2);
__decorateClass([
  type("string")
], GraphicSchema.prototype, "strokeColor", 2);
__decorateClass([
  type("number")
], GraphicSchema.prototype, "lineWidth", 2);
__decorateClass([
  type(GraphicCircleSchema)
], GraphicSchema.prototype, "circle", 2);
__decorateClass([
  type(GraphicEllipseSchema)
], GraphicSchema.prototype, "ellipse", 2);
__decorateClass([
  type(GraphicRectangleSchema)
], GraphicSchema.prototype, "rectangle", 2);
__decorateClass([
  type(["number"])
], GraphicSchema.prototype, "polygon", 2);
GraphicSchema = __decorateClass([
  Component("Graphic")
], GraphicSchema);
registerSchema(GraphicSchema);
const __vite_glob_0_25 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get GraphicSchema() {
    return GraphicSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  GraphicSchema as G,
  __vite_glob_0_25 as _
};
//# sourceMappingURL=Graphic-f0e31eeb.js.map
